var AchivementProgressComponent = (function () {
    function AchivementProgressComponent() {
    }
    AchivementProgressComponent.prototype.ngAfterViewInit = function () { };
    return AchivementProgressComponent;
}());
export { AchivementProgressComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/achievement/components/progressBar/progress-bar.component.ts.pre-build-optimizer.js